import PhoneNumberArea from 'src/components/common/formFields/phoneNumber/PhoneNumber';
import { componentSizeVariantsEnum } from 'src/constants';
import Label from 'src/components/common/formFields/label/Label';
import { useGetFormikField } from 'src/hooks';

import './previewField.scss';
import { TPreviewFieldProps } from './previewField.types';

const PhoneNumber = ({ id, label, validations, required, createProgramStep }: TPreviewFieldProps) => {
  // Hooks
  const { getFormikField } = useGetFormikField();

  const [field, fieldMetaData, helpers] = getFormikField({ id: id || '' });
  console.log('ssssssssss')
  return (
    <div key={id} className="dynamic-field">
      <Label required={required}>{label}</Label>
      <div className="dynamic-field__field">
        {' '}
        <PhoneNumberArea
          id={id}
          variant={componentSizeVariantsEnum.SMALL}
          placeholder={label}
          type="text"
          {...(validations?.maxCharacters < 3000 && { textLengthLimit: validations.maxCharacters })}
          value={field?.value}
          onChange={(e:any) => {
            console.log(e.target.value, 'console')
            helpers?.setValue(e.target.value);
          }}
          isTouched={fieldMetaData?.touched}
          errorMessage={fieldMetaData?.error}
          createProgramStep
        />
      </div>
    </div>
  );
};

export default PhoneNumber;
